import { useEffect, useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../../store';
import {
  fetchSmsSettings,
  saveSmsSettings,
  deleteSmsSettings,
  updateSmsSettings,
} from '../../store/slices/smsSettingsSlice';
import { SmsSettings } from '../../types/sms-settings';

export const useSmsSettings = () => {
  const dispatch = useDispatch<AppDispatch>();

  // Select SMS settings state from Redux

  // Get selected organization ID
  const selectedOrganizationId = useSelector(
    (state: RootState) => state.organizationContext.selectedOrganizationId
  );

  // Prevent multiple API calls
  const isFetchingRef = useRef(false);

  const fetchSmsSettingsData = useCallback(() => {
    if (selectedOrganizationId && !isFetchingRef.current) {
      isFetchingRef.current = true;
      dispatch(fetchSmsSettings(selectedOrganizationId)).finally(() => {
        isFetchingRef.current = false;
      });
    }
  }, [dispatch, selectedOrganizationId]);

  useEffect(() => {
    fetchSmsSettingsData();
  }, [fetchSmsSettingsData]);

  const saveSettings = (settings: SmsSettings) => {
    if (selectedOrganizationId) {
      return dispatch(
        saveSmsSettings({ organizationId: selectedOrganizationId, smsSettings: settings })
      );
    }
  };

  const updateSettings = (settings: SmsSettings) => {
    if (selectedOrganizationId) {
      return dispatch(
        updateSmsSettings({ organizationId: selectedOrganizationId, smsSettings: settings })
      );
    }
  };

  const deleteSettings = () => {
    return dispatch(deleteSmsSettings(selectedOrganizationId || ''));
  };

  return {
    selectedOrganizationId,
    refetch: fetchSmsSettingsData,
    saveSmsSettings: saveSettings,
    updateSmsSettings: updateSettings,
    deleteSmsSettings: deleteSettings,
  };
};
